import React from 'react';

import CalculatorForm from './CalculatorForm';
import SavingsBreakdown from './SavingsBreakdown';
import {
  DEFAULT_CIGS_SMOKED_DAILY,
  PACK_PRICE_BY_STORE,
} from '../appConstants';
import PropTypes from 'prop-types';

import CalculatorPageHeroBanner from './CalculatorPageHeroBanner';

export default class CalculatorPage extends React.Component {
  static propTypes = {
    annualAmountSavings: PropTypes.number,
    currency: PropTypes.string.isRequired,
    currencySymbol: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    shopNowPath: PropTypes.string.isRequired,
    storeCode: PropTypes.string,
  };

  defaultCigarettesPerDay = DEFAULT_CIGS_SMOKED_DAILY;

  defaultPricePerPack =
    parseFloat(PACK_PRICE_BY_STORE[this.props.storeCode]) || 0;

  componentDidMount() {
    this.props.onSubmit({
      cigarettes_per_day: this.defaultCigarettesPerDay,
      isPageLoad: true,
      price_per_pack: this.defaultPricePerPack,
    });
  }

  render() {
    const {
      annualAmountSavings,
      currency,
      currencySymbol,
      onSubmit,
      shopNowPath,
    } = this.props;

    return (
      <div className="calculator-page container-fluid">
        <div className="row">
          <div className="col-xs-12 calculator-page__hero-banner">
            <div className="row">
              <div className="col-xs-10 col-xs-offset-1 col-md-5 col-lg-5">
                <CalculatorPageHeroBanner shopNowPath={shopNowPath} />
              </div>
            </div>
          </div>
          <div className="col-xs-12 calculator-page__form-section">
            <div className="row">
              <div className="white-background col-xs-10 col-xs-offset-1 col-md-offset-1 col-md-4 calculator-page__form">
                <div className="row">
                  <div className="col-xs-10 col-xs-offset-1 calculator-page__card">
                    <CalculatorForm
                      currencySymbol={currencySymbol}
                      defaultCigarettesPerDay={this.defaultCigarettesPerDay}
                      defaultPricePerPack={this.defaultPricePerPack}
                      onSubmit={onSubmit}
                    />
                  </div>
                </div>
              </div>
              <div className="white-background col-xs-10 col-xs-offset-1 col-md-offset-1 col-md-5 calculator-page__savings-breakdown">
                <SavingsBreakdown
                  annualAmountSavings={annualAmountSavings}
                  currency={currency}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
